/* eslint-disable no-unused-vars */
// For enums

export enum DIRECTIONS {
    LEFT = 'left',
    RIGHT = 'right'
}

export const TRANSITION_MS = 600;

export const BREAKPOINTS = {
    BP_600: 600,
    BP_750: 750,
    BP_900: 900,
    BP_1000: 1000,
    BP_1160: 1160,
    BP_1300: 1300
};

export const DEFAULT_SLIDES_TO_SHOW = 1;

export const INDICATOR_DOTS_NUMBER = 4;

export enum SCROLL_TYPE {
    SINGLE = 'single',
    ROW = 'row'
}

export enum SWIPE_MODE_INDICATOR {
    DOTS = 1,
    HALF_CARD = 2
}
